import React from 'react';
import SubServices from '../common/sub-services';
const AboutServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 ">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <h2
                            className="text-primary  mb-2 fs-xl fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="100"
                        >
                            Our Mission and Vision Statement
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 lg:w-10/12 xl:w-8/12 mx-auto">
                    <SubServices
                        path={'/img/technology/ic-mission.svg'}
                        height={64}
                        width={64}
                        alt="mission"
                        title="mission"
                        serviceName="Our Mission"
                        serviceDescription="To engineer intelligent, secure, and scalable digital solutions that solve real problems, simplify workflows, and elevate organizations."
                        serviceDescriptiontwo="Empowering every client to achieve meaningful, measurable growth."
                    />

                    <SubServices
                        path={'/img/technology/ic-vision.svg'}
                        height={64}
                        width={64}
                        alt="vision"
                        title="vision"
                        serviceName="Our Vision"
                        serviceDescription="To become a global leader in AI-driven digital transformation"
                        serviceDescriptiontwo="where technology, design, and intelligence come together to build a smarter, more connected world for businesses and the people they serve"
                    />
                </div>
            </div>
        </div>
    );
};

export default AboutServies;
